// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"27935ccf","213":"ef6a38a6","363":"e3dad541","401":"ee612a00","455":"0e0016e7","849":"728a5607","890":"5514bcd7"}[chunkId] + ".chunk.js";
};